import * as React from 'react';
import MuiAlert from '@mui/material/Alert';

const StyledCommonAlertComp = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert
        elevation={6}
        ref={ref}
        variant="outlined"
        {...props}
    />;
});
export default StyledCommonAlertComp